const BeneInvalidRelationshipDirective = angular
    .module("beneInvalidRelationshipDirective", [])
    .directive("beneInvalidRelationshipValidator", [
        "beneficiaryService",
        "beneficiaryTypeService",
        function (beneficiaryService, beneficiaryTypeService) {
            return {
                restrict: "A",
                require: "ngModel",
                link: function (scope, elem, attr, ctrl) {
                    ctrl.$validators.beneInvalidRelationShip = function (value) {
                        var relation = beneficiaryService.getTypeOrRelationshipDisplay(
                            value,
                            beneficiaryTypeService.getTypes()
                        );
                        if (relation === undefined || relation === "Invalid details") {
                            return false;
                        } else {
                            return true;
                        }
                    };
                }
            };
        }
    ]);
export default BeneInvalidRelationshipDirective;
